export default __webpack_public_path__ + "static/media/agen_referral_cara2.cfeee938.svg";